import React, { MutableRefObject } from "react";
import { useParams } from "react-router-dom";
import BgLogo from "../../components/BgLogo";
import TransitionComp from "../../components/TransitionComp";
import "../../styles/About.css";
import {
  animateButton,
  resetAnimation,
  animateSingleProject,
} from "./helperAnimations";
import { useNavigate } from "react-router-dom";
import mainImg from "../../images/portfolio-img-main.png";
import anime from "animejs";
import {
  ArrowBack,
  Copy,
  CheckmarkDone,
  LogoInstagram,
  LogoGithub,
  LogoLinkedin,
} from "react-ionicons";
function AboutUs() {
  let params = useParams();
  console.log(params);
  const navigate = useNavigate();

  const [isCopied, setIsCopied] = React.useState(false);

  function openInNewTab(url: string) {
    var win = window.open(url, '_blank') as Window;
    win.focus();
  }
  const copyEmailAddress = () => {
    navigator.clipboard.writeText("mbajiakugeorge@yahoo.com");
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2500);
  };
  React.useEffect(() => {
    animateSingleProject();
  }, []);

  return (
    <>
      <TransitionComp children={<BgLogo />} />
      <div className="aboutUsMain">
        <div className="aboutLinkContainer">
          <div
            className="aboutNavLink"
            onClick={() => navigate("/")}
            onMouseEnter={() => animateButton(".aboutNavLink", "5px")}
            onMouseLeave={() => resetAnimation(".aboutNavLink", "0", false)}
          >
            <div>
              <ArrowBack color={"#6adb9d"} title={"Options"} />
            </div>
            <p style={{ fontSize: "26px", marginLeft: "30px" }}>Back Home</p>
          </div>

          <div
            className="emailRightDiv"
            onClick={() => copyEmailAddress()}
            onMouseEnter={() => animateButton(".emailDivWrapper", "-40px")}
            onMouseLeave={() =>
              resetAnimation(".emailDivWrapper", "0", isCopied)
            }
          >
            <div className="emailDivWrapper">
              <div className="emailMain">
                <p>mbajiakugeorge@yahoo.com</p>
              </div>
              <div className="copyEmailDiv">
                {isCopied ? (
                  <CheckmarkDone
                    color={"#121212"}
                    style={{ marginTop: "10px" }}
                    title={"Options"}
                  />
                ) : (
                  <Copy
                    color={"#121212"}
                    style={{ marginTop: "10px" }}
                    title={"Options"}
                  />
                )}
                <p>{!isCopied ? "Copy Email": "Copied"}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="aboutUsContainer">
          <div className="profile_img">
            <img src={mainImg} alt="img" />
          </div>
          <div className="profile_text">
            <p className="profile_text_1">
              Hello, I'm <span style={{ color: "#6adb9d" }}>George</span>
            </p>

            <p className="profile_text_2">
              I’m a Software Engineer currently based in the UK. I'm available
              for part-time, contract roles and freelance projects.
            </p>
          </div>
        </div>

        <div className="media">
        <ul>
          <li>
            <LogoGithub
              color={"#6adb9d"}
              height="20px"
              width="20px"
              onClick={() => openInNewTab("https://github.com/George5555ish")}
              title={"Github"}
              style={{cursor: 'pointer'}}
            />
          </li>
          <li>
            <LogoInstagram
              color={"#6adb9d"}
              height="20px"
              width="20px"
              onClick={() => openInNewTab("https://www.instagram.com/george_son_/")}
              title={"Instagram"}
              style={{cursor: 'pointer'}}
            />
          </li> 
          <li>
            <LogoLinkedin
              color={"#6adb9d"}
              height="20px"
              width="20px"
              onClick={() => openInNewTab("https://www.linkedin.com/in/george-mbajiaku-8747b2ab/")}
              title={"LinkedIn"}
              style={{cursor: 'pointer'}}
            />
          </li>
        </ul>
        </div>

        <div>
          <div className="profile_text_main" style={{ margin: "0 25px" }}>
            
            <div className="contact_details">
              <p className="profile_text_1">
                Phone Number:
                <span style={{ color: "#6adb9d" }}> +44-7939663626</span>
              </p>

              <p className="profile_text_1">
                Address:
                <span style={{ color: "#6adb9d" }}>
                  93, Beaumont Drive, Gravesend, DA11 9NR
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
